import { render, staticRenderFns } from "./ProblemaAudicion.vue?vue&type=template&id=98f47468"
import script from "./ProblemaAudicion.vue?vue&type=script&lang=js"
export * from "./ProblemaAudicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports